export function isFetchBaseQueryError(error) {
  return (
    typeof error === "object" &&
    error !== null &&
    "status" in error &&
    (typeof error.status === "number" ||
      error.status === "FETCH_ERROR" ||
      error.status === "PARSING_ERROR" ||
      error.status === "CUSTOM_ERROR")
  );
}

export function isSerializedError(error) {
  return (
    typeof error === "object" &&
    error !== null &&
    !("status" in error) &&
    ("message" in error || "name" in error)
  );
}

export function getErrorMessage(error) {
  if (isFetchBaseQueryError(error)) {
    if (typeof error.data === "string") {
      return error.data;
    }
    if (
      error.data &&
      typeof error.data === "object" &&
      "message" in error.data
    ) {
      return String(error.data.message);
    }
    if (error.error) {
      return error.error;
    }
    return `Error ${String(error.status)}`;
  }
  if (isSerializedError(error)) {
    return error.message ?? "An error occurred";
  }
  return "An unknown error occurred";
}
